import React from "react";
import { useSelector } from 'react-redux';
import Dropdown from "../../../../components/Dropdown";


const IndustrySection = ({ 
    formData,
    setFormData,
    industryOptions,
    industry1Options, 
    industry2Options,
    setIndustry2Options,
    industry3Options,
    setIndustry3Options,
    setDisplay }: any) => {

    const { talent, errors } = useSelector((state: any) => state.talentMypage)

    const handleChangeIndustryLevel1 = (value) => {
        setFormData((prev: any) => ({
          ...prev,
          industry_1: value,
          industry_2: null,
          industry_3: null,
        }));
        setDisplay(true);
    
        // Reload options level 2
        if (value && value.code) {
            setIndustry2Options(industryOptions.filter(item => item.parent_id == value.code && item.level == 2))
        } else {
            setIndustry2Options([])
        }
    
        // Reload options level 3
        setIndustry3Options([])
    }
    
      const handleChangeIndustryLevel2 = (value) => {
        setFormData((prev: any) => ({
          ...prev,
          industry_2: value,
          industry_3: null,
        }));
        setDisplay(true);
    
        // Reload options level 2
        if (value && value.code) {
            setIndustry3Options(industryOptions.filter(item => item.parent_id == value.code && item.level == 3))
        } else {
            setIndustry3Options([])
        }
    }

    return (
        <>
            <div className="flex flex-wrap gap-4 items-center mb-2">
              <p className="alu-text-base-2 text-base font-bold">経験した業種</p>
            </div>
            <div className="mt-4">
              <div className="mb-4">
                <label className="alu-text-base-2 text-sm font-bold mb-2">業種１</label>
                <Dropdown
                  error={errors?.industry_1}
                  errorText={errors?.industry_1}
                  options={industry1Options}
                  value={formData.industry_1}
                  onChange={(value: any) => handleChangeIndustryLevel1(value)}
                  placeholder="選択してください"
                  inputWidth="full"
                />
              </div>
              <div className="mb-4">
                <label className="alu-text-base-2 text-sm font-bold mb-2">業種２</label>
                <Dropdown
                  error={errors?.industry_2}
                  errorText={errors?.industry_2}
                  options={industry2Options}
                  value={formData.industry_2}
                  onChange={(value: any) => handleChangeIndustryLevel2(value)}
                  placeholder="選択してください"
                  inputWidth="full"
                  disabled={!formData.industry_1}
                />
              </div>
              <div>
                <label className="alu-text-base-2 text-sm font-bold mb-2">業種３</label>
                <Dropdown
                  error={errors?.industry_3}
                  errorText={errors?.industry_3}
                  options={industry3Options}
                  value={formData.industry_3}
                  onChange={(value: any) => {
                    setFormData((prev) => ({ ...prev, industry_3: value }));
                    setDisplay(true);
                  }}
                  placeholder="選択してください"
                  inputWidth="full"
                  disabled={!formData.industry_2}
                />
              </div>
            </div>
        </>
    )
};

export default IndustrySection;